import { reaction } from '../utils/preact-utils';
import { getAnalyticsService } from '../TrackAnalyticsHelper';
import { VideoStore } from './video.store';

// TODO: Migrate TrackAnalyticsHelper/AnalyticsService into this ?
// There is a lot of things to do with the Analytics part, for now it's only used to update the mediaFile and videoSizes in the AnalyticsService
// when available, and send monitoring events (legacy events have not been migrated yet...)
export class AnalyticsStore {
  videoStore: VideoStore;

  constructor(videoStore: VideoStore) {
    this.videoStore = videoStore;

    this.setupObservers();
  }

  setupObservers(): void {
    reaction(
      () => this.videoStore.mediaFile.value,
      mediaFile => {
        const analyticsService = getAnalyticsService();

        if (!analyticsService) {
          return;
        }

        analyticsService.setMediaFile(mediaFile);
      }
    );

    reaction(
      () => this.videoStore.videoSizes,
      () => {
        this.updateVideoSizesForAnalyticsService();
      }
    );
  }

  // Consider using this method instead of all the utility functions in TrackAnalyticsHelper..
  sendEvent(
    type: 'monitoring', // to be extended with creative, track, etc
    eventName: string
  ): void {
    const analyticsService = getAnalyticsService();

    if (!analyticsService) {
      return;
    }

    if (type === 'monitoring') {
      analyticsService.sendVideoMonitoringEvent(eventName);
    }
  }

  // At term, the sendEvent methods should be placed here so we don't need to update the AnalyticsService {videoSizes} from outside.
  // Accessing rootStore from Analytics service introduce a circular dependency so this temporary solution is used.
  updateVideoSizesForAnalyticsService(): void {
    const analyticsService = getAnalyticsService();
    analyticsService?.setVideoSizes(this.videoStore.videoSizes);
  }
}
